import React from 'react'
import styles from "./Templatepage.module.css"
import { Link } from 'react-router-dom'
import { useTheme } from '../../Themes/ThemeContext'

const TemplateHeader = () => {
    const { theme } = useTheme()

    return (
        <header class={styles.header}>
            <div class={styles.container}>
                <nav class={styles.nav}>
                    <Link to={"/home"} className={styles.logo}>
                        <img src={theme === "dark" ? process.env.PUBLIC_URL + "/images/dark-logo.png" : process.env.PUBLIC_URL + "/images/white-logo.png"}
                            alt='editlatex_logo' />
                    </Link>
                    <ul class={styles.nav_links}>
                        {/* <li><a href="categories.html" class={styles.active}>Categories</a></li>
                            <li><a href="#about">About</a></li> */}
                        <li><a href="/dashboard/myprojects">Projects</a></li>
                    </ul>
                </nav>
            </div>
        </header>
    )
}

export default TemplateHeader